<template>
  <div class="favorites">
    <div class="header">
      <i class="material-icons">star</i>
      <h3>
        {{ $store.state.user.langEng ? "Favorites" : "Favoriter" }}
      </h3>
      <i
        v-if="isMobile"
        class="material-icons rubbish-bin"
        @click="toggleAddFavorites()"
        >{{ toggleRemove ? "close" : "delete" }}
      </i>
    </div>
    <div v-if="favorites.length > 0" class="sidenav-close">
      <div v-for="favorite of favorites" :key="favorite.id">
        <favorite-item :article="favorite" :toggleRemove="toggleRemove" />
      </div>
    </div>
    <p v-else>
      {{
        $store.state.user.langEng
          ? "You have no favorites"
          : "Du har inga favoriter"
      }}
    </p>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import FavoriteItem from "./FavoriteItem";

@Component({ components: { FavoriteItem } })
export default class Favorites extends Vue {
  toggleRemove = false;

  toggleAddFavorites() {
    this.toggleRemove = !this.toggleRemove;
  }

  get favorites() {
    return this.$store.state.user.favorites;
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }
}
</script>

<style scoped lang="scss">
.favorites {
  position: relative;
  .header {
    align-items: center;
    display: grid;
    column-gap: 0.5em;
    grid-template-columns: auto 1fr auto;
    margin: 0.5em 0 0.5em;
    h3 {
      font-size: 1.5rem;
    }
  }
}
</style>
